import { z } from "zod";

export const attendanceSymbolSchema = z.enum([
  "P",
  "A",
  "HD/P",
  "HD/A",
  "WFH",
  "L",
  "H",
  "WO",
  "U",
]);

export const attendanceRegisterCellSchema = z
  .object({ date: z.string(), symbol: attendanceSymbolSchema })
  .strict();

export const attendanceRegisterRowSchema = z
  .object({
    membershipId: z.string(),
    memberName: z.string(),
    shiftTypeId: z.string().nullable(),
    shiftTypeName: z.string().nullable(),
    cells: z.array(attendanceRegisterCellSchema),
  })
  .strict();

export const attendanceRegisterSchema = z
  .object({ rows: z.array(attendanceRegisterRowSchema), month: z.string() })
  .strict();

export type AttendanceRegister = z.infer<typeof attendanceRegisterSchema>;
